export const challenges = {
  // ─── Signed Out ──────────────────────────────────────────────────────

  'challenges.sign-out.text':
    'Sign in to see all your challenges and get special rewards ',
  'challenges.sign-out.sign-in-or-join': 'Sign in or join',

  // ─── Signed In ───────────────────────────────────────────────────────

  'challenges.signed-in.header': 'Rewards & Challenges',

  // ─── Rewards ─────────────────────────────────────────────────────────

  'challenges.rewards.header': 'Your rewards',
  'challenges.rewards.railFooterText': 'Rewards will be added at checkout',
  'challenges.rewards.railDeadlinePrefixText': 'Ends',
  'challenges.rewards.noRewardsText': 'No rewards available at the moment.',
  'challenges.rewards.modal.text':
    'After you start your order, you will be able to apply this reward in the bag. Please make sure the rewards products are in your bag, before proceeding to checkout',
  'challenges.rewards.modal.terms':
    'Additional terms and conditions apply to the use of such reward.',
  'challenges.rewards.see-my-rewards': 'See my rewards',
  'challenges.rewards.use-again': 'Use again {distanceToDate}',
  'challenges.rewards.premium-label': 'Sweetpass + Benefit',
  'challenges.rewards.deadline-prefix': 'Ends',
  'challenges.rewards.sweetpass-deadline-prefix': 'Use by',

  // ─── Challenges ──────────────────────────────────────────────────────

  'challenges.challenges.header': 'Your challenges',
  'challenges.challenges.noChallengesText':
    'No challenges available at the moment.',

  // ─── Challenge Errors ────────────────────────────────────────────────

  'challenges.challenges.error.network-error': `There was an issue fetching your challenges. Please try again later.`,

  // ─── Reward Errors ───────────────────────────────────────────────────

  'challenges.rewards.error.network-error': `There was an issue fetching your rewards. Please try again later.`,
  'challenges.rewards.error.not-applicable': `This order might not meet the conditions of the reward selected, so it will not be applied at checkout.`,
  'challenges.rewards.error.loyalty-program-unavailable': `We're experiencing issues with our rewards program at the moment. Apologies for the inconvenience.`,
  'challenges.rewards.error.loyalty-not-processed': `We're experiencing issues with our rewards program at the moment. Apologies for the inconvenience.`,
  'challenges.rewards.error.expired': `Your selected reward has expired and will not be applied at checkout.`,
  'challenges.rewards.error.not-found': `We were unable to apply your selected reward, so it will not be applied at checkout.`,
  'challenges.rewards.error.server-error': `Something went wrong with the reward.`,
  'challenges.rewards.error.start-server-error': `Something went wrong with this challenge.`,
  'challenges.rewards.error.restaurant-not-accepting-orders': `Online ordering is currently unavailable at this location.`,
};
